const analytics = {
  registerNotification () {
    let eventType = arguments[0]

    if (eventType === 'dataLayer') {
      let event = arguments[1]

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(event)
    } else {
      let gaArguments = []

      for (let i = 0, l = arguments.length; i <= l; i++) {
        gaArguments[i] = arguments[i]
      }

      if (!window.ga) {
        return
      }

      window.ga(gaArguments)
    }
  },
  pushAnalyticsEvent (event, obj) {
    let eventObject = {
      event: event
    }
    this.registerNotification('dataLayer', Object.assign(eventObject, obj))
  }
}

export default analytics
